import * as types from './ActionTypes';

export const requestHERELocation = (type) => {
    return {
        type,
        receivedAt: Date.now()
    };
};

export const receiveHERELocation = (type, json) => {
    let location = null;
    if (json.items && json.items.length > 0) {
        let position = json.items[0].position;
        location = [position.lat, position.lng];
    }
    return {
        type,
        location: location,
        receivedAt: Date.now()
    };
};

export const fetchHERELocation = (searchText, hereToken) => ({
    type: types.FETCH_HERE_LOCATION,
    searchText,
    hereToken
});

export const resetHERELocation = () => ({
    type: types.RESET_HERE_LOCATION
});
